<template>
      <div class="">
        <div class=" container-signup">
            <div class="container">
                <div class="signup-content">
                    <form  id="signup-form" class="signup-form">
                        <h2 class="form-title">Create account</h2>
                        <div class="form-group">
                            <input type="email" class="form-input" name="email" id="email" placeholder="Your Email"/>
                        </div>
                        <div class="form-group">
                            <input type="password" class="form-input" name="password" id="password" placeholder="Password"/>
                            <span  @click="onHide"  class="btn zmdi zmdi-eye toggle-password field-icon" id="toggle-password"></span>
                        </div>
                       
                        <div class="form-group">
                            <input type="submit" name="submit" id="submit" class="form-submit" value="Sign in"/>
                        </div>
                    </form>
                    <p class="loginhere">
                        Have already an account ? <router-link to="/signup" class="loginhere-link">Register here</router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    setup(){
        return{
            hide : true
        }
    },
    methods:{
        onHide(){
             const passwordField = document.querySelector('#password')
             const getclassAtr = document.querySelector('#toggle-password')
              if (passwordField.getAttribute('type') === 'password'){
                  passwordField.setAttribute('type', 'text')  
                  getclassAtr.setAttribute('class','zmdi zmdi-eye-off field-icon');
              } else{
                  passwordField.setAttribute('type', 'password')
                  getclassAtr.setAttribute('class','zmdi zmdi-eye field-icon');
              }
        }
    }
}
</script>

<style lang="css" src="../assets/css/style.css" scoped>

</style>